/**
 * GA4 events for the signup wizard
 */

import { trackEvent } from '../../ga-event.js';
import { getStepName } from '../steps.js';

export function trackStep(step) {
    trackEvent('sign_up_step', {
        'step_number': step,
        'step_name': getStepName(step)
    });
}

export function trackStepBack(fromStep, toStep) {
    trackEvent('sign_up_step_back', {
        'step_number': fromStep,
        'step_name': getStepName(fromStep),
        'to_step_name': getStepName(toStep)
    });
}

// Fires for every move validation stopped, shown to the user or not, for every
// server rejection and for a failed request. Field names and reason codes only:
// a value the user typed must never reach GA.
export function trackError(step, field, reason) {
    trackEvent('sign_up_error', {
        'step_number': step,
        'step_name': getStepName(step),
        'field': field || '',
        'reason': reason || ''
    });
}
